import { createContext, ReactNode, useContext } from "react"

type SidebarContextType = {
  onActiveChatChange: (chatJid: string) => void
  onNavigate?: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

type SidebarProviderProps = {
  children: ReactNode
  onActiveChatChange: (chatJid: string) => void
  onNavigate?: () => void
}

export const SidebarProvider = ({
  children,
  onActiveChatChange,
  onNavigate,
}: SidebarProviderProps) => {
  return (
    <SidebarContext.Provider value={{ onActiveChatChange, onNavigate }}>
      {children}
    </SidebarContext.Provider>
  )
}

// Base buttons also render independently (for example, in settings/tests).
export const useSidebarNavigation = () => useContext(SidebarContext)?.onNavigate

export const useSidebar = () => {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider")
  }
  return context
}
